export const environment = {
  production: false,
  apiUrl: 'http://hr-api.trustedpos.org/api',
  apiOrigin: 'http://hr-api.trustedpos.org',
  wsUrl: 'ws://localhost:5282/hubs'
};
